module.exports = __webpack_public_path__ + "static/img/102130.42fc1d03.png";